import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

const control = "grid h-10 w-10 place-items-center rounded-[4px] border border-black/20 bg-transparent text-[#161616] transition-colors hover:border-black/70 hover:bg-black/5 active:bg-black/10 disabled:cursor-default disabled:opacity-30 disabled:hover:bg-transparent dark:border-white/25 dark:text-white dark:hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ce3830]";

/** Keyboard- and touch-friendly buttons, disabled at the carousel edges. */
export default function RailArrows({ onPrev, onNext, canPrev = true, canNext = true, className = "" }) {
  const { t } = useLang();
  return (
    <div className={`flex shrink-0 gap-1 ${className}`}>
      <button type="button" onClick={onPrev} disabled={!canPrev} aria-label={t("carousel.previous")} className={control}>
        <ChevronLeft className="h-4 w-4" aria-hidden="true" />
      </button>
      <button type="button" onClick={onNext} disabled={!canNext} aria-label={t("carousel.next")} className={control}>
        <ChevronRight className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
